import { Component, inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-wordpress-installed-dialog',
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule, FontAwesomeModule],
  templateUrl: './wordpress-installed-dialog.component.html',
  styleUrl: './wordpress-installed-dialog.component.scss',
})
export class WordpressInstalledDialogComponent {
  readonly dialogRef = inject(MatDialogRef<WordpressInstalledDialogComponent>);

  readonly data = inject<DialogData>(MAT_DIALOG_DATA);

  goToInstallation(): void {
    this.dialogRef.close({ install: true });
  }

  deleteWordpress(): void {
    this.dialogRef.close({ delete: true });
  }

  close(): void {
    this.dialogRef.close();
  }
}
